"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.wait = void 0;
function wait(waitTimeMs) {
    return new Promise(resolve => setTimeout(resolve, waitTimeMs));
}
exports.wait = wait;
//# sourceMappingURL=Utils.js.map